'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _providePage = require('./providePage');

var _providePage2 = _interopRequireDefault(_providePage);

var _provideSetting = require('./provideSetting');

var _provideSetting2 = _interopRequireDefault(_provideSetting);

var _provideStorage = require('./provideStorage');

var _provideStorage2 = _interopRequireDefault(_provideStorage);

var _adaptTransferringData = require('./adaptTransferringData');

var _adaptTransferringData2 = _interopRequireDefault(_adaptTransferringData);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _compose2.default)(_providePage2.default,
// x-route => page
_provideSetting2.default,
// x-config, page => schema, uiSetting
_provideStorage2.default,
// page.view => db
_adaptTransferringData2.default);

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'connectServer');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/connectServer/index.js
// module id = 1116
// module chunks = 0